// extracted by mini-css-extract-plugin
module.exports = {"avatarArea":"Avatar_avatarArea__RMbAp"};